import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { BrowserNotCompatibleDialogBodyComponent } from './browser-not-compatible/browser-not-compatible-dialog-body/browser-not-compatible-dialog-body.component';
import { BrowserNotCompatibleDialogComponent } from './browser-not-compatible/browser-not-compatible-dialog/browser-not-compatible-dialog.component';
import { MaintenanceModeAlertComponent } from './maintenance-mode-alert/maintenance-mode-alert.component';

@NgModule({
    declarations: [
        MaintenanceModeAlertComponent,
        BrowserNotCompatibleDialogComponent,
        BrowserNotCompatibleDialogBodyComponent
    ],
    imports: [CommonModule, MaterialModule],
    exports: [
        MaintenanceModeAlertComponent,
        BrowserNotCompatibleDialogComponent,
        BrowserNotCompatibleDialogBodyComponent
    ]
})
export class NotificationsModule {}
